module.exports = __webpack_public_path__ + "static/media/slideshow-3.d9ee4494.png";